module.exports = __webpack_public_path__ + "img/brand_8.4dde0ed7.png";